export default __webpack_public_path__ + "img/schedule.8a891b77.svg";